import React from "react";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";

import TestBoxes from "assets/images/Transparent backgrod 3D image-01.png";

import "./Sidebar.css";

const Sidebar = () => {
  return (
    <aside className="oc-sidebar bg-white h-100">
      <div className="d-flex flex-column justify-content-center align-items-center h-100 text-center">
        <Image src={TestBoxes} alt="test boxes" />
        <span className="oc-sidebar-title">Need a Test?</span>
        <p>Find the right lab test for your pet.</p>
        <Button
          href="https://oncotect.co/products/cancer-screening-test-kit"
          variant="primary"
          className="oc-btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          Shop
        </Button>
      </div>
    </aside>
  );
};

export default Sidebar;
